import { Button } from '@latitude/button';
import { Icon } from '@latitude/icons';

type ToggleButtonProps = {
  onClick: () => void;
};

const ToggleButton = ({ onClick }: ToggleButtonProps) => {
  return (
    <Button
      onClick={onClick}
      className="fixed bottom-2 right-2"
      variant="neutral"
      type="outline"
      aria-label="Toggle dev tools"
    >
      {<Icon name="settings" title="Settings" />}
    </Button>
  );
};

export default ToggleButton;
